import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses, accessNested } from 'utils/utils';
import s from 'components/bolt/videos/playlist/playlist.sss';
import VideosPlaylistItem from 'components/bolt/videos/playlist/playlistItem';

export default class VideosPlaylist extends Component {
	constructor(props) {
		super(props);
		this.refs = {};
	}

	render(props) {
		const { videos, changeActiveVideo, activeVideo, hidden } = props;
		const sonyHeaderEnabled = accessNested(Store.get(), 'appData.options.sonyFeatures.sonyHeader', false);

		return (
			<div
				ref={ref => this.$scroller = ref}
				class={joinClasses(s.container, hidden && s.hidden, sonyHeaderEnabled && s.sonyHeader)}
			>
				{videos.map((vid) => (
					<VideosPlaylistItem
						ref={ref => this.refs[vid.key] = ref}
						item={vid}
						onClick={() => changeActiveVideo(vid)}
						activeVideo={activeVideo}
						key={vid.key}
					/>
				))}
			</div>
		);
	}
}
